import { useQuery } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const LICENSE_METRICS_QUERY_KEY = "license_metrics";
const getMetrics = () => SystemLicenses.getMetrics();
const useLicenseMetrics = () => {
  const { data, isFetching, isLoading, isError, refetch } = useQuery({
    queryKey: [LICENSE_METRICS_QUERY_KEY],
    queryFn: () => onError(getMetrics(), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(
          i18n.t("notifications.metrics_failed", { ns: "enterprise_license", error: errorThrown })
        );
      }
    })
  });
  return {
    data,
    isFetching,
    isLoading,
    isError,
    refetch
  };
};
export default useLicenseMetrics;
